export const RATING_DESC = "Highest Rating";
export const RATING_ASC = "Lowest Rating";
export const NEWEST = "Most Recent";
export const REVIEWS_PER_PAGE = 6;
